import {
  MEMBER_BADGE_HASH_PREFIX,
  buildMemberBadgeHash,
  isMemberBadgeHash,
  readMemberBadgeTemplateIdFromHash,
} from '@communities/common-layer/utils/member-badge-hash.utils'

export { MEMBER_BADGE_HASH_PREFIX, buildMemberBadgeHash, isMemberBadgeHash, readMemberBadgeTemplateIdFromHash }

/** Legacy query key — middleware redirects `?badge=` → `#badgeTemplateId=`. */
export const MEMBER_BADGE_QUERY_KEY = 'badge'

const firstQueryValue = (value: unknown): string => {
  if (Array.isArray(value)) {
    return typeof value[0] === 'string' ? value[0].trim() : ''
  }

  return typeof value === 'string' ? value.trim() : ''
}

export const readMemberBadgeTemplateIdFromQuery = (query: Record<string, unknown> | null | undefined): string | null => {
  const badgeTemplateId = firstQueryValue(query?.[MEMBER_BADGE_QUERY_KEY])
  return badgeTemplateId || null
}

/** Query keys that conflict with badge-hash membership filtering. */
const MEMBER_STATUS_QUERY_KEY = 'memberStatus'

/**
 * Strip legacy `?badge=` (and `memberStatus`, which would otherwise win on the
 * next middleware pass and drop the badge hash) while preserving other params
 * such as search.
 */
export const buildMembersQueryWithoutBadge = (query: Record<string, unknown> | null | undefined): Record<string, string> => {
  const nextQuery: Record<string, string> = {}

  for (const [key, value] of Object.entries(query ?? {})) {
    if (key === MEMBER_BADGE_QUERY_KEY || key === MEMBER_STATUS_QUERY_KEY) {
      continue
    }

    const stringValue = firstQueryValue(value)
    if (stringValue) {
      nextQuery[key] = stringValue
    }
  }

  return nextQuery
}
